import { render, staticRenderFns } from "./OverviewDetail.vue?vue&type=template&id=5e1d1889&scoped=true&"
import script from "./OverviewDetail.vue?vue&type=script&lang=js&"
export * from "./OverviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./OverviewDetail.vue?vue&type=style&index=0&id=5e1d1889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1d1889",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VIcon,VRating,VRow,VSkeletonLoader})
